// Use current origin for API calls to avoid CORS issues on custom domains
// When deployed at nazca360.com, API calls must go to nazca360.com/api
// not to the internal deployment host (peru-heritage-vr.emergent.host)
export const BACKEND_URL = window.location.origin;
export const API = `${BACKEND_URL}/api`;
